import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Ic } from "../shared";
import TrialWelcomeModal, { markTrialWelcomeModalSeen } from "./TrialWelcomeModal";

const COLLAPSE_KEY = "carthub_trial_bar_collapsed_v1";

export default function TrialTrialBar({ variant, onGoToSubscription }) {
  const { t } = useTranslation("trial");
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [readerOpen, setReaderOpen] = useState(false);

  useEffect(() => {
    try {
      if (collapsed) localStorage.setItem(COLLAPSE_KEY, "1");
      else localStorage.removeItem(COLLAPSE_KEY);
    } catch {}
  }, [collapsed]);

  const bottom = { paddingBottom: "max(16px, env(safe-area-inset-bottom))" };

  if (collapsed) {
    return (
      <>
        <button
          type="button"
          aria-label={t("bar.ariaFab")}
          onClick={() => setCollapsed(false)}
          style={{
            position: "fixed",
            right: 16,
            bottom: `max(16px, env(safe-area-inset-bottom))`,
            width: 44,
            height: 44,
            borderRadius: "50%",
            border: "1px solid rgba(26,26,26,0.1)",
            background: "#fff",
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            cursor: "pointer",
            zIndex: 1030,
            fontSize: 18,
            fontWeight: 700,
            color: "#0A85CF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          i
        </button>
        <TrialWelcomeModal
          open={readerOpen}
          welcomeFlow={false}
          onClose={() => setReaderOpen(false)}
          variant={variant}
          onGoToSubscription={() => {
            setReaderOpen(false);
            onGoToSubscription?.();
          }}
        />
      </>
    );
  }

  return (
    <>
      <div
        role="region"
        aria-label={t("bar.ariaRegion")}
        style={{
          position: "fixed",
          right: 16,
          bottom: 0,
          ...bottom,
          zIndex: 1030,
          maxWidth: "min(380px, calc(100vw - 32px))",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 14,
            border: "1px solid rgba(26,26,26,0.1)",
            boxShadow: "0 10px 40px rgba(0,0,0,0.14)",
            padding: "14px 16px",
          }}
        >
          <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
            <span style={{ color: "#0A85CF", display: "flex", flexShrink: 0 }} aria-hidden>
              {Ic.mail}
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1a1a", marginBottom: 6 }}>{t("bar.title")}</div>
              <p style={{ margin: 0, fontSize: 13, lineHeight: 1.55, color: "#4b5563" }}>
                {variant === "agency" ? (
                  <>
                    {t("bar.bodyAgencyPrefix")}
                    <strong>{t("bar.bodyAgencyStrong")}</strong>
                    {t("bar.bodyAgencySuffix")}
                  </>
                ) : (
                  <>
                    {t("bar.bodyDirectPrefix")}
                    <strong>{t("bar.bodyDirectStrong")}</strong>
                    {t("bar.bodyDirectSuffix")}
                  </>
                )}
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 12, alignItems: "center" }}>
                <button
                  type="button"
                  onClick={() => setReaderOpen(true)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: "#0A85CF",
                    fontWeight: 600,
                    fontSize: 13,
                    cursor: "pointer",
                    textDecoration: "underline",
                    textUnderlineOffset: 2,
                  }}
                >
                  {t("bar.readAll")}
                </button>
                {variant === "direct" && (
                  <button
                    type="button"
                    onClick={() => {
                      markTrialWelcomeModalSeen();
                      onGoToSubscription?.();
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "#6b7280",
                      fontWeight: 500,
                      fontSize: 13,
                      cursor: "pointer",
                      textDecoration: "underline",
                      textUnderlineOffset: 2,
                    }}
                  >
                    {t("bar.subscriptionPage")}
                  </button>
                )}
              </div>
            </div>
            <button
              type="button"
              aria-label={t("bar.collapse")}
              onClick={() => setCollapsed(true)}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: "#9ca3af",
                display: "flex",
                padding: 2,
              }}
            >
              {Ic.x}
            </button>
          </div>
        </div>
      </div>
      <TrialWelcomeModal
        open={readerOpen}
        welcomeFlow={false}
        onClose={() => setReaderOpen(false)}
        variant={variant}
        onGoToSubscription={() => {
          setReaderOpen(false);
          onGoToSubscription?.();
        }}
      />
    </>
  );
}
